module.exports = __webpack_public_path__ + "static/media/router.bf30acad.png";